import { render, staticRenderFns } from "./ComplaintResolutionMechanism.vue?vue&type=template&id=2d0aef0f&scoped=true"
import script from "./ComplaintResolutionMechanism.vue?vue&type=script&lang=js"
export * from "./ComplaintResolutionMechanism.vue?vue&type=script&lang=js"
import style0 from "./ComplaintResolutionMechanism.vue?vue&type=style&index=0&id=2d0aef0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0aef0f",
  null
  
)

export default component.exports